import {useQuery} from "react-query";
import {UserServices} from "../../Services/users";
import Constants from "../../Utils/Constants";

export const useGetAllParentVendors= () =>{
    return useQuery([Constants.REACT_QUERY.QUERY_KEY.GET_ALL_PARENT_VENDORS],()=> UserServices.getParentVendors(),{
        refetchOnWindowFocus: false,
        refetchOnMount:true
    })
}